import React, { useState } from 'react';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { Link } from "react-router-dom"
import Logo from "../assets/Logo transparent.png"

const Navbar = () => {

  const [nav, setNav] = useState(false);
  const handleNav = () => {
    setNav(!nav);
  };
  const navItems = [
    { id: 1, myText: 'Home' , link:'/' },
    { id: 2, myText: 'About us', link:'/about' },
    { id: 3, myText: 'Why Choose Us', link: '/why-choose-us' },
    { id: 4, myText: 'Services', link:'/service' },
    { id: 5, myText: 'Contact', link:'/contact'},
  ];

  return (
    <div className=' flex justify-between items-center h-38  max-w-full mx-auto px-4 text-white'>
      <Link to="/" className="text-3xl">
        <img src={Logo} className='w-60 hover:scale-110 transition-all cursor-pointer' alt='oz wide cover pty ltd' />
         </Link>
      <ul className='hidden md:flex'>
        {navItems.map(item => (
          <li
            key={item.id}
            className='p-4 text-black text-center hover:underline hover:scale-110 rounded-xl m-2 cursor-pointer duration-300 hover:text-black '
          >
            <Link to={item.link}>{item.myText}</Link>
          </li>
        ))}
      </ul>
      <ul className={nav ? 'fixed md:hidden left-0 top-0 w-[50%] h-full border-r border-r-gray-900 bg-[#000300] ease-in-out duration-500': 'ease-in-out w-[40%] duration-500 fixed top-0 bottom-0 left-[-100%]'}>
        <Link to="/" className="text-3xl">
        <img src={Logo} className='w-60 hover:scale-110 transition-all cursor-pointer' alt='oz wide cover pty ltd' />
         </Link>
        {navItems.map(item => (<>
          <li
            key={item.id}
            className='p-4 border-b rounded-xl hover:bg-white duration-300 hover:text-black cursor-pointer border-gray-600'
          >
            <Link to={item.link}>{item.myText}</Link>
          </li>
        </>))}
        <div className='flex flex-col gap-10 mt-5'>
        <li ><Link to="tel:0452322420" className="w-96 h-96 p-8 text-center py-3 border border-[#c8a876] text-white font-medium rounded-md hover:bg-[#c09858] hover:text-black transition duration-200">Call us</Link></li>
        <li><Link to='/quote' className=" p-8 text-center py-3 border border-[#c8a876] text-white font-medium rounded-md hover:bg-[#c09858] hover:text-black transition duration-200">Get a Quote</Link></li>

        </div>
      </ul>

      <div className='relative items-center justify-center gap-5 hidden md:flex lg:visible'>
        <Link to="tel:0452322420" className="w-40 text-center py-3 border border-[#c8a876] text-black font-medium rounded-md hover:bg-[#c09858] transition duration-200">Call us</Link>
        <Link to='/quote' className=" text-black p-3 w-40 text-center md:px-8 rounded-md border border-yellow-500 hover:bg-yellow-500 hover:text-white shadow transition ">Get a Quote</Link>
        </div>


        <div onClick={handleNav} className='block lg:hidden text-black cursor-pointer'>
        {nav ? <AiOutlineClose size={40} /> : <AiOutlineMenu size={40} />}
      </div>
    </div>
  );
};


export default Navbar;
